import { Popconfirm } from 'antd';
import { v4 as uuid } from 'uuid';

export const getTableColumns = (deleteEntity) => [
  {
    title: 'Entity Name',
    key: 'entityName',
    render: ({ name }) => name,
  },
  {
    title: '',
    key: uuid(),
    render: ({ name }) => (
      <Popconfirm
        title={`You are about to delete ${name} from your organization`}
        onConfirm={() => deleteEntity(name)}
        okText="Confirm"
        cancelText="Cancel"
      >
        <span style={{ cursor: 'pointer', textDecoration: 'underline' }}>
          Remove{' '}
        </span>
      </Popconfirm>
    ),
  },
];
